import {ISettingsGetter} from '@wix/tpa-settings'
import settingsParams from '../../components/widget/settingsParams'
import {ALL_CATEGORIES_FILTER} from '../constants/settings'

export const getCategoryMenuIds = (getSetting: ISettingsGetter): string[] => {
  const categoryMenuIdsString = getSetting(settingsParams.categoryMenuIds) as string
  return categoryMenuIdsString ? categoryMenuIdsString.split(',') : [ALL_CATEGORIES_FILTER]
}

export const getInitialCategoryId = (getSetting: ISettingsGetter): string => {
  const initialCategoryId = getSetting(settingsParams.initialCategoryId) as string
  const defaultCategoryId = initialCategoryId || ALL_CATEGORIES_FILTER
  const categoryMenuIds = getCategoryMenuIds(getSetting)

  if (categoryMenuIds.includes(defaultCategoryId)) {
    return defaultCategoryId
  }

  return categoryMenuIds[0] || ALL_CATEGORIES_FILTER
}
